import {Quantity} from "@/model/Quantity";
import {OrderedProductStatus} from "@/model/OrderedProductStatus";
import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";

export class RelatedOrder implements Serializable {
    
    orderId: string;
    orderNumber: string;
    dueDate: Date;
    quantity: Quantity;
    status: OrderedProductStatus;
    
    fromJSON(obj: any) {
        SerializationHelper.copyNonExcludedProperties(this, obj, []);
    }
}